import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectNavigation } from 'src/app/store/common/navigation/navigation.selector';

@Component({
    selector: 'loading-bar',
    templateUrl: './loading-bar.component.html',
    styleUrls: ['./loading-bar.component.scss']
})

export class LoadingBarComponent implements OnInit {
    loading = false;

    constructor(public store: Store) {

    }

    ngOnInit(): void {
        this.loadNavigation();
    }

    loadNavigation() {
        this.store.select(selectNavigation)
            .subscribe(data => {
                this.loading = false;

                const { loading } = data;
                if (loading)
                    this.loading = loading;
            });
    }

}




